/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotificationDto = {
    id?: string;
    installmentPlanId?: string;
    financierId?: string;
    shopId?: string;
    title?: string;
    message?: string;
    type?: NotificationDto.type;
    readAt?: string;
    readById?: string;
    readByUserName?: string;
    createdAt?: string;
    updatedAt?: string;
};
export namespace NotificationDto {
    export enum type {
        NOTIFICATION = 'NOTIFICATION',
        INSTALLMENT_MESSAGE = 'INSTALLMENT_MESSAGE',
        INSTALLMENT_STATUS = 'INSTALLMENT_STATUS',
    }
}

